export default "__VITE_ASSET__CQSz4YMG__"